import { Container } from '@/components';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import TabHeader from '@/components/TabHeader/TabHeader';
import {
  faBookmark,
  faReply,
  faShare,
} from '@fortawesome/free-solid-svg-icons';
import { TabView, TabPanel } from 'primereact/tabview';
import styles from './WorkOrder.module.scss';
import ANPImport from './components/ANPImport';
import ANPExport from './components/ANPExport';
import ANPBooking from './components/ANPBooking';
import ANPSharedExport from './components/ANPSharedExport';

enum Tabs {
  ANPImportTab = 0,
  ANPExportTab = 1,
  ANPSharedExportTab = 2,
  ANPBookingTab = 3,
}

const WorkOrder: FC = () => {
  const { t } = useTranslation('workOrder');
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Container title={t('generateWorkOrder')} className={styles.workOrder}>
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel
          header={
            <TabHeader
              active={activeIndex === Tabs.ANPImportTab}
              label={t('anpImport')}
              icon={faReply}
              className={styles.tabHeader}
            />
          }
        >
          <ANPImport />
        </TabPanel>
        <TabPanel
          header={
            <TabHeader
              active={activeIndex === Tabs.ANPExportTab}
              label={t('anpExport')}
              icon={faShare}
              className={styles.tabHeader}
            />
          }
        >
          <ANPExport />
        </TabPanel>
        <TabPanel
          header={
            <TabHeader
              active={activeIndex === Tabs.ANPSharedExportTab}
              label={t('anpExportShared')}
              icon={faShare}
              className={styles.tabHeader}
            />
          }
        >
          <ANPSharedExport />
        </TabPanel>
        <TabPanel
          header={
            <TabHeader
              active={activeIndex === Tabs.ANPBookingTab}
              label={t('anpBooking')}
              icon={faBookmark}
              className={styles.tabHeader}
            />
          }
        >
          <ANPBooking />
        </TabPanel>
      </TabView>
    </Container>
  );
};

export default WorkOrder;
